import {FeaturesService} from '@/app/features/services/features.service';
import {Routes} from '@/app/shared/consts/routes';
import {LanguageService} from '@/app/shared/services/language.service';
import {NotificationService} from '@/app/shared/services/notification.service';
import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {Router} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {catchError, Observable, of, Subscription} from 'rxjs';
import {SafeResourceUrl} from "@angular/platform-browser";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-cursos-destacados',
    imports: [MatCardModule, MatButtonModule, TranslatePipe, AsyncPipe],
    templateUrl: './cursos-destacados.html',
    styleUrl: './cursos-destacados.scss',
})
export class CursosDestacadosComponent implements OnInit, OnDestroy {
    public routes: typeof Routes = Routes;
    courses = signal<any[]>([]);
    private subscription!: Subscription;

    cursos = signal([
        {
            name: 'COURSES.ONCOLOGY.TITLE',
            description: 'COURSES.ONCOLOGY.DESCRIPTION',
            recourseUrl: 'assets/images/oncologia.jpg',
            professorName: 'COURSES.ONCOLOGY.PROFESSOR',
            creditMessage: 'COURSES.ONCOLOGY.CREDITS',
            link: '',
        },
        {
            name: 'COURSES.DENTISTRY.TITLE',
            description: 'COURSES.DENTISTRY.DESCRIPTION',
            recourseUrl: 'assets/images/odontologia.svg',
            professorName: 'COURSES.DENTISTRY.PROFESSOR',
            creditMessage: 'COURSES.DENTISTRY.CREDITS',
            link: '',
        },
        {
            name: 'COURSES.CARDIOLOGY.TITLE',
            description: 'COURSES.CARDIOLOGY.DESCRIPTION',
            recourseUrl: 'assets/images/cardiologia.jpg',
            professorName: 'COURSES.CARDIOLOGY.PROFESSOR',
            creditMessage: 'COURSES.CARDIOLOGY.CREDITS',
            link: '',
        },
        {
            name: 'COURSES.RADIOTHERAPY.TITLE',
            description: 'COURSES.RADIOTHERAPY.DESCRIPTION',
            recourseUrl: 'assets/images/radioterapia.svg',
            professorName: 'COURSES.RADIOTHERAPY.PROFESSOR',
            creditMessage: 'COURSES.RADIOTHERAPY.CREDITS',
            link: '',
        },
        // {
        //   titulo: 'COURSES.NUCLEAR_MEDICINE.TITLE',
        //   descripcion: 'COURSES.NUCLEAR_MEDICINE.DESCRIPTION',
        //   imagen: 'assets/images/medicina_nuclear.svg',
        //   link: '',
        // },
        // {
        //   titulo: 'COURSES.INDUSTRIAL_RESEARCH.TITLE',
        //   descripcion: 'COURSES.INDUSTRIAL_RESEARCH.DESCRIPTION',
        //   imagen: 'assets/images/investigacion.svg',
        //   link: '',
        // },
    ]);


    constructor(private router: Router,
                private featuresService: FeaturesService,
                protected ngxLoaderService: NgxUiLoaderService,
                private notificacionService: NotificationService,
                private languageService: LanguageService,
                private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.subscription = this.languageService.currentLang$.subscribe(lang => {
            this.getAllCourses();
        });
    }

    goToLogin() {
        this.router.navigate([this.routes.LOGIN]);
    }

    getAllCourses(): void {
        this.ngxLoaderService.start();
        let resul : SafeResourceUrl| null;
        this.featuresService.getAllConfigCoursesLanding().subscribe({
            next: (res) => {
                // @ts-ignore
                res.forEach(curso => {
                    curso.safeResourcePhoto$ = this.loadPhoto(curso.recourseUrl);
                });

                this.courses.set(res);
                // for (let i = 0; i < this.courses().length; i++) {
                //     resul = this.loadPhoto(this.courses()[i].recourseUrl);
                //     this.courses()[i].safeResourcePhoto = resul;
                // }

                this.ngxLoaderService.stop();
            },
            error: (err) => {
                this.ngxLoaderService.stop();
            },
        });
    }

    loadPhoto(rutaFoto: string): Observable<SafeResourceUrl> {
        // @ts-ignore
        return this.featuresService.getPhoto(rutaFoto).pipe(
            catchError(err => {
                this.notificacionService.notificationError(
                    this.translate.instant('ERRORS.SORRY_ERROR') + err,
                    this.translate.instant('COMMON.ERROR')
                );
                return of(null);
            })
        );
    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
